// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__23GHW","Logo":"Toolbar_Logo__o7liU","DesktopOnly":"Toolbar_DesktopOnly__3ztBS"};